import { useState } from "react";
import "./News.css";

const ALL_CATEGORIES = ["All", "Games", "Dev", "Tools", "Announcement"];

function News({ news = [], announcements = [], authors = [] }) {
  const [activeTab, setActiveTab] = useState("All");
  const author = authors[0];

  const featuredItem = news.find((n) => n.featured) || news[0];

  const filtered =
    activeTab === "All"
      ? news
      : news.filter((n) =>
          n.category?.some((c) =>
            c.toLowerCase().includes(activeTab.toLowerCase()),
          ),
        );

  const rest = filtered.filter((n) => n.id !== featuredItem?.id);

  return (
    <>
      <div className="page-hero">
        <div className="page-hero__inner">
          <div className="sec-eyebrow">Updates</div>
          <h1 className="page-hero__title">
            NEWS &amp;
            <br />
            DEVLOGS
          </h1>
          <p className="page-hero__sub">
            Dev logs, release notes, game updates and community announcements
            from all active projects.
          </p>
        </div>
      </div>

      <section className="section">
        <div className="container">
          {announcements.length > 0 && (
            <div
              style={{
                marginBottom: 2,
                display: "flex",
                flexDirection: "column",
                gap: "1px",
                background: "var(--border)",
                border: "1px solid var(--border)",
              }}
            >
              {announcements.map((ann) => (
                <div
                  key={ann.id}
                  style={{
                    background: "var(--bg2)",
                    padding: "20px 32px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 20,
                    flexWrap: "wrap",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
                    <span className={`badge badge--${ann.priority || "low"}`}>{ann.type}</span>
                    <span style={{ fontWeight: 600, fontSize: 14, color: "var(--white)" }}>
                      {ann.title}
                    </span>
                  </div>
                  <span style={{ fontSize: 12, color: "var(--muted)", whiteSpace: "nowrap" }}>
                    {ann.date}
                  </span>
                </div>
              ))}
            </div>
          )}

          {featuredItem && (
            <div className="news-featured">
              <div className="news-featured__img">
                <span className="news-featured__img-text">
                  {featuredItem.projectId?.toUpperCase() || "NEWS"}
                </span>
              </div>
              <div className="news-featured__body">
                <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                  <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: "2px", textTransform: "uppercase", color: "var(--muted)" }}>
                    {featuredItem.date}
                  </span>
                  {featuredItem.category?.map((c) => (
                    <span key={c} className="tag">{c}</span>
                  ))}
                  <span className="badge badge--high">Featured</span>
                </div>
                <div className="news-featured__title">{featuredItem.title}</div>
                <p className="news-featured__content">{featuredItem.content}</p>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  {featuredItem.tags?.map((t) => (
                    <span key={t} className="tag">{t}</span>
                  ))}
                </div>
                <div style={{ display: "flex", gap: 12, alignItems: "center", marginTop: 8 }}>
                  <span style={{ fontSize: 12, color: "var(--muted)" }}>
                    by {author?.nickname}
                  </span>
                  {featuredItem.externalLinks?.map((l) => (
                    <a key={l.url} href={l.url} target="_blank" rel="noreferrer" className="btn btn--sm btn--ghost">
                      {l.type} →
                    </a>
                  ))}
                </div>
              </div>
            </div>
          )}

          <div className="filter-bar">
            {ALL_CATEGORIES.map((c) => (
              <button
                key={c}
                className={`filter-btn${activeTab === c ? " filter-btn--active" : ""}`}
                onClick={() => setActiveTab(c)}
              >
                {c}
              </button>
            ))}
          </div>

          {rest.length > 0 ? (
            <div className="news-grid">
              {rest.map((item) => (
                <div key={item.id} className="news-card">
                  <div className="news-card__meta">
                    <span className="news-card__date">{item.date}</span>
                    {item.category?.slice(0, 2).map((c) => (
                      <span key={c} className="tag">{c}</span>
                    ))}
                  </div>
                  <div className="news-card__title">{item.title}</div>
                  <p className="news-card__content">{item.content}</p>
                  <div className="news-card__tags">
                    {item.tags?.map((t) => (
                      <span key={t} className="tag">{t}</span>
                    ))}
                  </div>
                  <div className="news-card__footer">
                    <span className="news-card__author">by {author?.nickname}</span>
                    <div style={{ display: "flex", gap: 8 }}>
                      {item.externalLinks?.slice(0, 1).map((l) => (
                        <a key={l.url} href={l.url} target="_blank" rel="noreferrer" className="btn btn--sm btn--ghost">
                          {l.type} →
                        </a>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="empty-state">No news in this category yet.</div>
          )}
        </div>
      </section>
    </>
  );
}

export default News;
